import React, { useEffect, useImperativeHandle, forwardRef } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import IconExpand from '@mui/icons-material/ExpandMore';
import IconCollapse from '@mui/icons-material/ExpandLess';
import ColorPalette from '../../../colorpalette/ColorPalette';
import style from './FilterList.module.css';
import { Badge, Tooltip } from "@mui/material";

const FilterList = forwardRef(({ id, label, filters, onChange, initOpened, defaultChecked }, ref) => {

    const getLocalStorageInfo = () =>  {
        const localStorageValue = localStorage.getItem(localStorageKey);
        if (localStorageValue) return JSON.parse(localStorageValue);
        // Se defaultChecked for fornecido, usa ele; senão marca todos por padrão
        return defaultChecked !== undefined
            ? defaultChecked
            : Array.from(filters.map((item, index) => index));
    }

    const localStorageKey = "filterList-"+id;
    const [checkedItems, setCheckedItems] = React.useState(getLocalStorageInfo());
    const [opened, setOpened] = React.useState(initOpened);

    // Expõe método para controle externo via ref
    useImperativeHandle(ref, () => ({
        /**
         * Define os índices ativos externamente (substitui o estado atual).
         * Útil para acionar filtros programaticamente (ex: botão "Ver pendentes").
         */
        setCheckedItems: (items) => {
            setCheckedItems(items);
        },
        /**
         * Adiciona um índice aos itens marcados sem remover os existentes.
         */
        addCheckedItem: (index) => {
            setCheckedItems(prev =>
                prev.includes(index) ? prev : [...prev, index]
            );
        },
        getCheckedItems: () => checkedItems,
    }));

    const GetFilterNotUsedCount = () => {
        return filters.length-checkedItems.length;
        }

    let message = GetFilterNotUsedCount() == 1? `Existe ${GetFilterNotUsedCount()} item não selecionado` : `Existem ${GetFilterNotUsedCount()} itens não selecionados`;

    useEffect(() => {
         const json = JSON.stringify(checkedItems);
         localStorage.setItem(localStorageKey , json);
        onChange(checkedItems);
    }, [checkedItems]);

    const handleChange = (event) => {
        const index = parseInt(event.target.name);
        if (checkedItems.includes(index)) {
            setCheckedItems(checkedItems.filter(item => item != index));
        } else {
            setCheckedItems([...checkedItems, index]);
        }
    };

    const isChecked = (index) =>
    {
        return checkedItems.includes(index);
    }

    const onOpenCloseClickHandle = () => {
        setOpened(!opened);
    };

    return (
        <div className={style.container}>
            <div className={style.containerTitle} onClick={onOpenCloseClickHandle}>
                <div className={style.titleLeft}>
                    <span className={style.titleLabel}>{label}</span>
                    {GetFilterNotUsedCount() > 0 && (
                        <Tooltip title={message} arrow>
                            <Badge badgeContent={GetFilterNotUsedCount()} color="primary" fontSize="small">
                                <span />
                            </Badge>
                        </Tooltip>
                    )}
                </div>
                {opened ? <IconCollapse className={style.titleIcon} /> : <IconExpand className={style.titleIcon} />}
            </div>
            {opened && (
                <div className={style.containerItems}>
                    {filters.map((item, index) => (
                        <FormControlLabel
                            key={index}
                            label={<span style={{ fontSize: '14px'}}>{item}</span>}
                            control={
                                <Checkbox
                                    checked={isChecked(index)}
                                    sx={{
                                        '& .MuiSvgIcon-root': { fontSize: 14 }, color: ColorPalette.textDark,
                                        '&.Mui-checked': {
                                            color: ColorPalette.secondary,
                                        }
                                    }}
                                    onChange={handleChange}
                                    name={index}
                                />}
                        />
                    ))}
                </div>
            )}
        </div>
    );
});


export default FilterList;